import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field, Form, Formik } from 'formik';
import { lighten } from '@material-ui/core/styles';
import { useValidator } from '../../../utils/validators';
import { CircularProgress } from '@material-ui/core';
import {
  getDifferenceInDaysBetweenTwoDates,
} from '../../../utils/dates-utils';
import CommonMultiSelectField from '../../common/form/CommonMultiSelectField';
import CommonSelectField from '../../common/form/CommonSelectField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DatePicker from '../../common/form/DatePicker';
import withStyles from '@material-ui/core/styles/withStyles';
import Radio from '@material-ui/core/Radio';
import { TODAY } from '../../../utils/dates-const';
import {
  getLabelForNextButton,
  getLabelForPrevButton,
  TODAY_AS_DATE, updateDateRangeFields,
} from '../reports/standard/StandardReportUtils';
import {
  STANDARD_INPUT_HEIGHT,
  STANDARD_INPUT_RADIUS,
  STANDARD_INPUT_WIDTH,
} from '../../../const/chart-const';
import {
  ALMOST_BLACK_COLOR, ALMOST_WHITE_COLOR,
  BACKGROUND_WHITE,
  BLACK_COLOR,
  DARK_BORDER_COLOR, FRESHDESK_GREY,
  LIGHT_GREY_COLOR,
} from '../../../const/color-const';
import { TRANSACTION_DATE_OPTIONS } from './TransactionConfig';
import CommonButton from '../../common/CommonButton';
import CommonDivider from '../../common/CommonDivider';
import RadioButtonsGroup from '../../common/form/RadioButtonsGroup';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ArrowRightIcon } from '@material-ui/pickers/_shared/icons/ArrowRightIcon';
import { ArrowLeftIcon } from '@material-ui/pickers/_shared/icons/ArrowLeftIcon';
import classNames from 'classnames';

const [CASH_REGISTER_HEIGHT_MOBILE, CASH_REGISTER_HEIGHT] = [48, 60];
const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  formContent: {
    width: '100%',
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    '& div': {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        '& label + .MuiInput-formControl-432': {
          marginTop: 14,
        },
      },
      '& div[class*="MuiFormGroup"]': {
        alignItems: 'center',
        justifyContent: 'center',
        '& .commonSelectField': {
          marginLeft: 0,
          height: CASH_REGISTER_HEIGHT_MOBILE,
          [theme.breakpoints.up('md')]: {
            height: CASH_REGISTER_HEIGHT,
          },
        },
        '& label[class*="MuiFormControlLabel"]:nth-child(3)': {
          [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(3),
          },
        },
      },
      '& .MultiSelectField': {
        margin: theme.spacing(1),
        height: CASH_REGISTER_HEIGHT_MOBILE,
        [theme.breakpoints.up('md')]: {
          margin: theme.spacing(2),
          height: CASH_REGISTER_HEIGHT,
        },
        '& div[class*="selectItem"]': {
          borderRadius: STANDARD_INPUT_RADIUS,
        },
      },
      '& .commonSelectField': {
        width: STANDARD_INPUT_WIDTH,
        backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
        height: CASH_REGISTER_HEIGHT_MOBILE,
        [theme.breakpoints.down('md')]: {
          margin: theme.spacing(1),
        },
        [theme.breakpoints.up('md')]: {
          height: CASH_REGISTER_HEIGHT,
        },
        '& div[class*="select"]': {
          borderRadius: STANDARD_INPUT_RADIUS,
        },
      },
      '& .dateTimePickerWrapper': {
        height: CASH_REGISTER_HEIGHT_MOBILE,
        [theme.breakpoints.up('md')]: {
          height: CASH_REGISTER_HEIGHT,
        },
      },
      '& > [class*="MuiTextField"]': {
        '& label:not(.Mui-focused):not([class*="MuiFormLabel-filled"])': {
          marginTop: -10,
        },
        '& [class*="MuiInputAdornment"]': {
          marginBottom: 4,
        },
      },
    },
  },
  datePickersWrapper: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& div.Mui-error > input': {
      marginBottom: 7,
    },
    '& p.Mui-error': {
      whiteSpace: 'nowrap',
      position: 'absolute',
      bottom: -10,
      left: 2,
    },
    '& bottom': {
      marginBottom: 7,
    },
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: theme.spacing(1, 2, 1, 0),
      width: STANDARD_INPUT_WIDTH,
      height: STANDARD_INPUT_HEIGHT,
      borderRadius: STANDARD_INPUT_RADIUS,
      backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
      border: theme.palette.type === 'light' ? `1px solid ${LIGHT_GREY_COLOR}` : `1px solid ${DARK_BORDER_COLOR}`,
      '&:hover': {
        border: theme.palette.type === 'light' ? `1px solid ${BLACK_COLOR}` : `1px solid white`,
      },
      '& label': {
        marginLeft: 10,
        marginTop: 0,
      },
      '& input': {
        marginLeft: 10,
        paddingTop: 0,
        marginTop: 0,
        height: '100%',
      },
      '& div': {
        '&::before': {
          display: 'none',
        },
        '&::after': {
          display: 'none',
        },
      },
    },
  },
  rangeButton: {
    border: theme.palette.type === 'light' ? `1px solid ${LIGHT_GREY_COLOR}` : `1px solid ${DARK_BORDER_COLOR}`,
    backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
    color: theme.palette.type === 'light' ? BLACK_COLOR : ALMOST_WHITE_COLOR,
    borderRadius: STANDARD_INPUT_RADIUS,
    margin: theme.spacing(2),
    width: 220,
    padding: 0,
    height: CASH_REGISTER_HEIGHT_MOBILE,
    [theme.breakpoints.up('md')]: {
      height: CASH_REGISTER_HEIGHT,
    },
    [theme.breakpoints.up('md')]: {
      width: 154,
      height: STANDARD_INPUT_HEIGHT,
    },
    '&:hover': {
      border: theme.palette.type === 'light' ? `1px solid ${BLACK_COLOR}` : `1px solid white`,
      background: 'none',
      boxShadow: 'none',
    },
    '& > span': {
      justifyContent: 'space-between',
      display: 'flex',
      height: '100%',
      width: '100%',
      padding: 0,
      margin: 0,
      '& span[class*="MuiButton-label"]': {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
  rangeButtonPrev: {
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1.5, 0, 0, 0),
    },
    '& span[class*="MuiButton-label"]': {
      '& span[class*="startIcon"]': {
        margin: 0,
        maxWidth: 36,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.type === 'light' ? FRESHDESK_GREY : ALMOST_BLACK_COLOR,
      },
    },
  },
  rangeButtonNext: {
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, 2, 1.5, 0),
    },
    '& span[class*="MuiButton-label"]': {
      '& span[class*="endIcon"]': {
        margin: 0,
        maxWidth: 36,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.type === 'light' ? FRESHDESK_GREY : ALMOST_BLACK_COLOR,
      },
    },
  },
  btnLabel: {
    width: '100%',
  },
  loadingBar: {
    marginTop: theme.spacing(2),
  },
  searchBtn: {
    width: 136,
    height: CASH_REGISTER_HEIGHT_MOBILE,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 148,
      height: 56,
    },
  },
});

const DATE_RANGE_CUSTOM = 'custom';
const DATE_RANGE_SELECTED = 'selected';

const RECEIPTS_AND_INVOICES = {
  label: <FormattedMessage id="form.transactions.receipts.and.invoices" defaultMessage="Receipts and invoices" />,
  value: 0,
};

const ONLY_INVOICES = {
  label: <FormattedMessage id="form.transactions.only.invoices" defaultMessage=" Only invoices" />,
  value: 1,
};

const ONLY_RECEIPTS = {
  label: <FormattedMessage id="form.transactions.only.receipts" defaultMessage="Only receipts" />,
  value: 2,
};

const validator = ({ values, intl: { formatMessage } }, Version) => {
  const { dateFrom, dateTo } = values;
  const errors = {};
  
  if (getDifferenceInDaysBetweenTwoDates(dateFrom, dateTo) >= 6) {
    errors.dateFrom = formatMessage({
      id: 'form.standard.transactions.date.max7.days.date.range',
      defaultMessage: 'Max date range is 7 days',
    });
    errors.dateTo = formatMessage({
      id: 'form.standard.transactions.date.max7.days.date.range',
      defaultMessage: 'Max date range is 7 days',
    });
  }
  
  if (Version === 'Basic') {
    const today = new Date();
    if (getDifferenceInDaysBetweenTwoDates(dateFrom, today) >= 9) {
      errors.dateFrom = formatMessage({
        id: 'form.standard.transactions.date.max10.days.earlier',
        defaultMessage: 'Date cannot exceed 10 days back',
      });
    }
  }
  return errors;
};

const RECEIPTS_AND_INVOICES_OPTIONS = [RECEIPTS_AND_INVOICES, ONLY_RECEIPTS, ONLY_INVOICES];

const TransactionsForm = ({
                            classes,
                            fetchTransactionReports,
                            machinesOptions,
                            setFormValues,
                            setCurrentPageId,
                            user: { LicenseInfo: { Version } },
                          }) => {
  const [dateRangeOption, setDateRangeOption] = useState(DATE_RANGE_SELECTED);
  const [dateRangeValue, setDateRangeValue] = useState(TODAY.value);
  const formValidator = useValidator(values => validator(values, Version));
  const formikRef = useRef();
  
  const handleDateRangeChange = (value, validateForm) => {
    setDateRangeValue(value);
    validateForm();
  };
  
  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        machineIDs: [null],
        dateFrom: TODAY_AS_DATE,
        dateTo: TODAY_AS_DATE,
        dateRange: TODAY.value,
        transactionType: RECEIPTS_AND_INVOICES.value,
      }}
      onSubmit={(values, formikHelpers) => {
        setFormValues({ values, formikHelpers });
        fetchTransactionReports(values, formikHelpers);
        setCurrentPageId(0);
      }}
      validate={formValidator}>
      {({ isSubmitting, values, setFieldValue, isValid, validateForm }) => {
        return (
          <Form className={classes.form}>
            <div className={classes.formContent}>
              <div className={classes.formContentTopRow}>
                <Field
                  wide
                  atLeastOneElement
                  name="machineIDs"
                  label={
                    <FormattedMessage
                      id="field.cash.register"
                      defaultMessage="Cash Register"
                    />}
                  options={[...machinesOptions, {
                    label: <>- <FormattedMessage
                      id="all"
                      defaultMessage="All"
                    /> -</>, value: null,
                  }]}
                  component={CommonMultiSelectField}
                />
                
                <Field
                  wide
                  name="transactionType"
                  label={<FormattedMessage id="field.transaction.type" defaultMessage="Transaction type" />}
                  options={RECEIPTS_AND_INVOICES_OPTIONS}
                  component={CommonSelectField}
                />
              </div>
              
              <RadioButtonsGroup
                handleChange={(value) => {
                  setDateRangeOption(value);
                }}
                value={dateRangeOption}
                options={[
                  <React.Fragment key="prev">
                    <CommonButton
                      size="large"
                      startIcon={<ArrowLeftIcon />}
                      label={getLabelForPrevButton(dateRangeValue, classes)}
                      className={classNames(classes.rangeButton, classes.rangeButtonPrev)}
                      onClick={() => updateDateRangeFields('previous', values, setFieldValue, validateForm, dateRangeValue)}
                    />
    
                    <FormControlLabel
                      key={`${DATE_RANGE_CUSTOM}startDate`}
                      label={
                        <div className={classes.datePickersWrapper}>
                          <Field
                            name="dateFrom"
                            label={<FormattedMessage id="date.field.date.from" defaultMessage="Date from" />}
                            component={DatePicker}
                          />
                          <Field
                            name="dateTo"
                            label={<FormattedMessage id="date.field.date.to" defaultMessage="Date to" />}
                            component={DatePicker}
                          />
          
                          <CommonButton
                            size="large"
                            endIcon={<ArrowRightIcon />}
                            label={getLabelForNextButton(dateRangeValue, classes)}
                            className={classNames(classes.rangeButton, classes.rangeButtonNext)}
                            onClick={() => updateDateRangeFields('next', values, setFieldValue, validateForm, dateRangeValue)}
                          />
                        </div>
                      }
                      value={DATE_RANGE_CUSTOM}
                      control={<Radio />}
                    />
    
                    <FormControlLabel
                      key={`${DATE_RANGE_CUSTOM}endDate`}
                      label={
                        <Field
                          date
                          name="dateRange"
                          extraHandleChangeAction={(value) => handleDateRangeChange(value, validateForm)}
                          label={<FormattedMessage id="date.field.date.range" defaultMessage="Date range" />}
                          options={TRANSACTION_DATE_OPTIONS}
                          component={CommonSelectField}
                        />
                      }
                      value={DATE_RANGE_SELECTED}
                      control={<Radio />}
                    />
                  </React.Fragment>,
                ]}
              />
            </div>
  
            <CommonButton
              className={classes.searchBtn}
              isAnimated
              searchButton={true}
              size="large"
              type="submit"
              label={<FormattedMessage
                id="search"
                defaultMessage="Search"
              />}
              disabled={isSubmitting || !values.machineIDs || !values.dateFrom || !values.dateTo || !isValid}
            />
            
            {isSubmitting && <CircularProgress className={classes.loadingBar} />}
            
            <CommonDivider />
          </Form>
        );
      }}
    </Formik>
  );
};

TransactionsForm.propTypes = {
  classes: PropTypes.object,
  fetchTransactionReports: PropTypes.func,
  machinesOptions: PropTypes.array,
};

const decorate = compose(withStyles(styles),
  connect(store => ({ user: store.user.profile })));
export default decorate(TransactionsForm);
